// extracted by mini-css-extract-plugin
module.exports = {"timeline":"Twitter-module--timeline--36w5K","fadeIn":"Twitter-module--fadeIn--2mcBd"};